import { render, staticRenderFns } from "./NurseProcedure.vue?vue&type=template&id=0872f46d"
import script from "./NurseProcedure.vue?vue&type=script&lang=js"
export * from "./NurseProcedure.vue?vue&type=script&lang=js"
import style0 from "./NurseProcedure.vue?vue&type=style&index=0&id=0872f46d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports